<template>
  <v-toolbar-items class="toolbar-items">
    <mostrador-data-hora class="ml-4"/>
    <v-tooltip bottom>
      <template v-slot:activator={on}>
        <v-btn icon v-on="on" class="btn-sair desktop" @click="logout()">
          <v-icon>mdi-exit-to-app</v-icon>
        </v-btn>
      </template>
      Sair do sistema
    </v-tooltip>
  </v-toolbar-items>
</template>

<script>
import {mutationTypes} from '@/core/constants'
import MostradorDataHora from '@/views/components/MostradorDataHora.vue'

export default {
    name: 'core-toolbar',
    components: {MostradorDataHora},
    data() {
        return {
            notifications: [],
            fotoEmpresa: null,
        }
    },
    methods: {
        logout() {
            this.$store.commit(mutationTypes.COMUM.EFETUAR_LOGOUT)
        }
    }
}
</script>

<style scoped lang="stylus">
.toolbar-items
  display flex
  align-items center

.toolbar-icon
  text-decoration none

.btn-sair
  margin-left 20px
  color #bbb
  letter-spacing 1px
  font-size 16px !important
  font-weight bold
  word-spacing 1px
  text-transform capitalize

@media (max-width 720px)
  .desktop
    display none
</style>